const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const Modal = require('app/ui/Modal');

const RestaurantForm = require('app/restaurant/Form');

class CreateModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': window.translate('app.restaurant.create.title'),
            'copyMode': false,
            'onClose': function(event){},
            'onShown': function(event){},
            'onSuccess': function(data){},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-create-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "full",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.loadData();

        this.modal.show();
    }


    loadData(){
        var self = this;

        let queries = [
            this.buildSellerQuery()
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildContent(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSellerQuery(){
        var self = this;


        let filters = {
            //'type': "agentco"
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
        };

        let fields = [
            'id',
            'user { lastName firstName }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'sellers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildContent(data){
        this.sellers = data.sellers.edges;

        this.infosForm = new RestaurantForm({
            'sellers': this.sellers,
            'success': this.settings.onSuccess,
        });

        this.$content.html('')
        .append(this.infosForm.getForm());
    }
}

module.exports = CreateModal;

